var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronRightSmall = function SvgChevronRightSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.70453 17.2946C8.31526 16.9053 8.31491 16.2743 8.70376 15.8846L12.5799 12L8.70376 8.11538C8.31491 7.72569 8.31526 7.09466 8.70453 6.70538C9.0941 6.31581 9.72572 6.31581 10.1153 6.70538L14.7028 11.2929C15.0933 11.6834 15.0933 12.3166 14.7028 12.7071L10.1153 17.2946C9.72572 17.6842 9.0941 17.6842 8.70453 17.2946Z",
    fill: "currentColor"
  })));
};
export default SvgChevronRightSmall;